
/*
  BOOKSY (2026-04-12) G3 fix: a stock-filter-container korabbi verzioja
  HARDCODED-an a /collections/raktaron-1-2-nap, /collections/partnerraktar-4-5-nap
  es /collections/beszallitoi-7-nap globalis kollekciokra mutatott. Igy ha a
  felhasznalo /collections/irodalom-on rakattintott a "Raktaron" gombra,
  atvitte az OSSZES raktaron levo termekre (kategoria-kontextus elveszett).

  Javitas: ha kategoria-kollekcion (irodalom, gyermek, eletmod, ...) vagyunk,
  akkor a gombok a current collection-on belul szurnek a Shopify natur
  /collections/{handle}/{tag} routingjat hasznalva. A delivery- prefixu tag-ek
  megfelelnek a stock-bucket kollekcioknak. Ha a current collection 1) a
  globalis stock-bucket kollekciok egyike, 2) /collections/all, vagy
  3) nem vagyunk collection oldalon → eredeti, abszolut URL-eket hasznaljuk.
*/
document.addEventListener('DOMContentLoaded', function() {
  var collGrid = document.querySelector('.collection-grid__wrapper');
  if (!collGrid) return;
  // MOBIL 2. kör (2026-09-26): a sávot a collection-grid.liquid már szerveroldalon rendereli (CLS-javítás) → itt nincs dolga.
  if (collGrid.querySelector('[data-bky-sf-server]')) return;

  var path = window.location.pathname;

  // Globalis stock-bucket es all kollekciok handlje (azokon kell az abszolut URL)
  var STOCK_BUCKETS = {
    'all': true,
    'raktaron-1-2-nap': true,
    'partnerraktar-4-5-nap': true,
    'beszallitoi-7-nap': true,
    'rendelesre-keszulo-konyvek': true
  };

  // Detect current collection handle from URL: /collections/{handle}[/{tag}]
  var collMatch = path.match(/^\/collections\/([^\/\?#]+)/);
  var currentColl = collMatch ? collMatch[1] : '';
  var isStockBucket = STOCK_BUCKETS[currentColl] === true;

  // delivery- tag prefix-ek amikre a stock-bucket-ok pillanatfelvetelben skalazodnak.
  // Az elso elem az "elsodleges" tag amit a /collections/{handle}/{tag} routingba
  // beleirunk; mivel a Shopify route csak EGYETLEN tag-et tud filtelni, az adott
  // bucketet legjobban reprezentalo (leggyakoribb / leggyorsabb) tag-et hasznaljuk.
  var TAG_FOR_BUCKET = {
    'raktaron-1-2-nap': 'delivery-1-2-munkanap',
    'partnerraktar-4-5-nap': 'delivery-4-7-munkanap',
    'beszallitoi-7-nap': 'delivery-13-17-munkanap'
  };

  var filters = [
    { label: 'Mind', bucket: null, abs: '/collections/all' },
    { label: 'Rakt\u00E1ron (1\u20133 nap)', bucket: 'raktaron-1-2-nap', abs: '/collections/raktaron-1-2-nap' },
    { label: 'Besz\u00E1ll\u00EDt\u00F3t\u00F3l (4\u20137 nap)', bucket: 'partnerraktar-4-5-nap', abs: '/collections/partnerraktar-4-5-nap' }
    // 'Beszallitoi (7+ nap)' filter 2026-04-16 eltavolitva user kerese alapjan.
    // A stock-badge (getStockBadge -> stock-badge--supplier) MEGMARAD: a
    // termekkartyan tovabbra is kijelzi a Beszallitoi statuszt, csak a szűrősávbol
    // tűnt el. Ha visszaallitanad: a sor beszurando a tömb vegere:
    //   { label: 'Besz\u00E1ll\u00EDt\u00F3i (7+ nap)', bucket: 'beszallitoi-7-nap', abs: '/collections/beszallitoi-7-nap' }
  ];

  // Build effective href: kategoria-kollekcion belul tag-scoped, egyebkent abszolut.
  function buildHref(f) {
    if (!currentColl || isStockBucket) return f.abs;
    if (f.bucket === null) {
      // "Mind" → vissza a kategoriara, tag nelkul
      return '/collections/' + currentColl;
    }
    var tag = TAG_FOR_BUCKET[f.bucket];
    return tag ? '/collections/' + currentColl + '/' + tag : f.abs;
  }

  var container = document.createElement('div');
  container.className = 'stock-filter-container';

  var label = document.createElement('div');
  label.className = 'stock-filter-label';
  label.textContent = 'SZ\u00C1LL\u00CDT\u00C1SI ID\u0150';
  container.appendChild(label);

  var btnWrap = document.createElement('div');
  btnWrap.className = 'stock-filter-buttons';
  container.appendChild(btnWrap);

  filters.forEach(function(f) {
    var href = buildHref(f);
    var a = document.createElement('a');
    a.className = 'stock-filter-btn';
    a.href = href;
    a.textContent = f.label;
    if (path === href || path === href + '/') {
      a.classList.add('active');
    }
    btnWrap.appendChild(a);
  });

  if (!btnWrap.querySelector('.active')) {
    var mindBtn = btnWrap.querySelector('.stock-filter-btn');
    if (mindBtn) mindBtn.classList.add('active');
  }

  var filterBar = collGrid.querySelector('.collection-filter');
  if (filterBar) {
    collGrid.insertBefore(container, filterBar);
  } else {
    collGrid.insertBefore(container, collGrid.firstChild);
  }
});

/*
  BOOKSY: Kosárba gomb + szerző + szállítási badge injektálás
  a recently-viewed és product-recommendations kártyákra.
  Ezek a theme JS-ből jönnek (buildProductGridItem), nem Liquid-ből,
  ezért utólag kell hozzáadni.
*/
(function() {
  function getStockBadge(tags, available) {
    // LÁTVÁNYTERV 2026-09-26: az ELFOGYOTT termék eddig „Beszállítói raktár · 4-7 munkanap” jelvényt kapott a kártyán
    // (a source:out_of_stock a beszállítói ágra esett). Most a products/*.js available mezője dönt.
    if (available === false) { return { cls: 'stock-badge--out', icon: '', label: 'Elfogyott', delivery: '' }; }
    // BOOKSY VOUCHER-JS v1: voucher-termekre specialis badge a JS oldalon is
    // (recently-viewed + product-recommendations dynamic cards).
    for (var j = 0; j < tags.length; j++) {
      if (tags[j] === 'gift-voucher' || tags[j] === 'ajandekutalvany') {
        return { cls: 'stock-badge--voucher', icon: '\u{1F381}', label: 'Azonnal k\u00E9zbes\u00EDtj\u00FCk', delivery: '' };
      }
    }
    var source = '', delivery = '';
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('source:') === 0) source = tags[i].replace('source:', '');
      if (tags[i].indexOf('delivery:') === 0) delivery = tags[i].replace('delivery:', '');
    }
    if (source === 'physical') {
      return { cls: 'stock-badge--instock', icon: '', label: 'Rakt\u00E1ron', delivery: '' };
    } else if (source === 'bookline') {
      // BOOKSY 2026-05-05 FIX: minden bookline-termek "Besz\u00E1ll\u00EDt\u00F3i rakt\u00E1r" + 4-7 munkanap (Liquid-konzisztens)
      return { cls: 'stock-badge--supplier', icon: '', label: 'Besz\u00E1ll\u00EDt\u00F3t\u00F3l', delivery: (delivery || '4-7 munkanap').replace('-', '\u2013') };
    } else if (source) {
      // Egyeb source (gemker, stb.) — default 4-7 munkanap ha nincs delivery-tag
      return { cls: 'stock-badge--supplier', icon: '', label: 'Besz\u00E1ll\u00EDt\u00F3t\u00F3l', delivery: (delivery || '4-7 munkanap').replace('-', '\u2013') };
    }
    return null;
  }

  function enhanceCards() {
    document.querySelectorAll('.grid-product__content').forEach(function(card) {
      if (card.dataset.booksyEnhanced) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var imageMask = card.querySelector('.grid-product__image-mask');
      if (!imageMask) return;

      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^\/?#]+)/);
      if (!match) return;
      var handle = match[1];

      card.dataset.booksyEnhanced = '1';

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json().then(function(json) { if (!r.ok) { throw new Error(json.description || json.message || 'cart-add hiba'); } return json; }); })
        .then(function(product) {
          var meta = card.querySelector('.grid-product__meta');
          if (!meta) return;

          /* Szerző (vendor) — ha nincs már benne, ÉS nem "Booksy"/"Default Title" (a bolt
             neve, NEM szerző) — 2026-05-06 fix.
             Elsősorban a book.author metafield > szerzo-* tag > vendor sorrendben.
             A book.author metafieldhez itt JS-ben nincs hozzáférés (Liquid-only),
             ezért a tag-ből próbálunk először. */
          var jsAuthor = '';
          (product.tags || []).forEach(function(t) {
            if (jsAuthor) return;
            if (typeof t === 'string' && t.indexOf('szerzo-') === 0) {
              jsAuthor = t.replace('szerzo-', '').replace(/-/g, ' ');
              jsAuthor = jsAuthor.charAt(0).toUpperCase() + jsAuthor.slice(1);
            }
          });
          if (!jsAuthor && product.vendor) {
            var v = (product.vendor || '').trim();
            var vLower = v.toLowerCase();
            if (vLower !== 'booksy' && vLower !== 'default title') {
              jsAuthor = v;
            }
          }
          if (jsAuthor && !meta.querySelector('.grid-product__vendor')) {
            var vendorEl = document.createElement('div');
            vendorEl.className = 'grid-product__vendor';
            vendorEl.textContent = jsAuthor;
            var titleEl = meta.querySelector('.grid-product__title');
            if (titleEl) {
              titleEl.parentNode.insertBefore(vendorEl, titleEl.nextSibling);
            } else {
              meta.appendChild(vendorEl);
            }
          }

          /* Szállítási badge — ha nincs már benne */
          if (!meta.querySelector('.stock-badge')) {
            var badge = getStockBadge(product.tags || [], product.available);
            if (badge) {
              var badgeEl = document.createElement('div');
              badgeEl.className = 'stock-badge ' + badge.cls;
              badgeEl.innerHTML = '<span class="stock-badge__icon">' + badge.icon + '</span>' +
                '<span class="stock-badge__label">' + badge.label + '</span>' +
                (badge.delivery ? ' <span class="stock-badge__delivery">\u00B7 ' + badge.delivery + '</span>' : '');
              meta.appendChild(badgeEl);
            }
          }

          /* Kosárba gomb */
          if (product.available && !card.querySelector('.quick-add-btn')) {
            var variantId = product.variants[0].id;
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'quick-add-btn';
            btn.dataset.variantId = variantId;
            btn.textContent = 'Kos\u00E1rba';
            imageMask.style.position = 'relative';
            imageMask.appendChild(btn);

            btn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              var origText = btn.textContent;
              btn.disabled = true;
              btn.textContent = '...';

              // FIX 2026-05-23 \u2014 r.ok check (l\u00E1sd quick-add-script.liquid: ugyanaz a bug volt).
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
              })
              .then(function(r) {
                return r.json().then(function(json) {
                  if (!r.ok) {
                    var msg = (json && (json.description || json.message)) || ('HTTP ' + r.status);
                    var err = new Error(msg);
                    err.shopify = json;
                    throw err;
                  }
                  return json;
                });
              })
              .then(function() {
                btn.textContent = '\u2713 Hozz\u00E1adva';
                setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1500);
                fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
                  document.querySelectorAll('.cart-link__count, .js-cart-count, [data-cart-count]').forEach(function(d){ d.textContent = cart.item_count; });
                  document.querySelectorAll('.cart-link__bubble').forEach(function(b){ if(cart.item_count > 0) b.classList.add('cart-link__bubble--visible'); });
                });
              })
              .catch(function(err) {
                try { if (window.console && console.warn) console.warn('card-enh add failed:', err); } catch(_) {}
                var msg = (err && err.message) ? String(err.message) : 'Hiba';
                btn.textContent = msg.length > 24 ? 'Nem el\u00E9rhet\u0151' : msg;
                setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 3500);
              });
            });
          }
        })
        .catch(function() { /* product not found, skip */ });
    });
  }

  // Run on load + observe DOM changes (recently-viewed loads async)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(enhanceCards, 500);
      setTimeout(enhanceCards, 2000);
    });
  } else {
    setTimeout(enhanceCards, 500);
    setTimeout(enhanceCards, 2000);
  }

  // MutationObserver for dynamically inserted cards
  var observer = new MutationObserver(function(mutations) {
    var hasNew = mutations.some(function(m) { return m.addedNodes.length > 0; });
    if (hasNew) setTimeout(enhanceCards, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
